import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApi } from 'src/backend/api/base-api';
import { LoggedUser } from 'src/backend/models/session-users/session-users';
import { core_features, lean_features } from 'src/@smartmanufacturing/common/custom_methods';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import * as CryptoJS from "crypto-js";
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TranslaterService } from 'src/app/services/translater.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() isMobMenuActive = false;
  @Output() menuChangeEvent = new EventEmitter();
  isMenuOpen = true;
  user!: LoggedUser;
  menus: any[] = [];
  langObject: any = {};
  languageDir = 'ltr';
  algorithm = Constants.HASH_ALGORITHEM;
  key = CryptoJS.enc.Utf8.parse(Constants.HASH_KEY);
  iv = CryptoJS.enc.Utf8.parse(Constants.HASH_IV);
  DynamicExists: boolean = false;
  dynamicDashboard: any;
  constructor(public router: Router, private baseApi: BaseApi,
    public translate: TranslateService, public translater: TranslaterService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'ar') {
        this.languageDir = 'rtl';
        this.getLangWords();
      } else if (event.lang === 'en') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else if (event.lang === 'fr') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else if (event.lang === 'sp') {
        this.languageDir = 'ltr';
        this.getLangWords();
      }
    });
  }


  ngOnInit(): void {
    this.getLangWords();
    this.user = this.baseApi.getUserSession();
    this.getMenulist();
  }

  menuToggler(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.menuChangeEvent.emit(this.isMenuOpen);
  }
  // getMenulist(): any {
  //   this.baseApi.getUserMenusSession()?.find(x => x.label === "Dynamic Dashboard")?this.DynamicExists = true:this.DynamicExists = false
  //   this.menus = this.baseApi.getUserMenusSession();
  // }

  getMenulist(): void {
    const menus = this.baseApi.getUserMenusSession();
    const dynamicDashboardIndex = menus.findIndex(menu => menu.label === "Dynamic Dashboard");
    if (dynamicDashboardIndex !== -1) {
      [this.dynamicDashboard] = menus.splice(dynamicDashboardIndex, 1);
    }
    this.menus = menus;
  }
  onClickMenu(menu: any): void {
    // if (core_features.includes(menu?.label)) {
    if (menu?.applicationVariant === Constants.CORE_APP_NAME || menu?.applicationVariant === Constants.UI_FORM_BUILDER_APP_NAME || menu?.applicationVariant === Constants.UTILITY_APP_NAME) {
      const appURL = this.baseApi.getAppURL(menu?.applicationVariant);
      const plantCode: string = this.baseApi.getPlantCodeFromStorage();
      const groupCode: string = this.baseApi.getGroupCodeFromStorage();
      const queryParams = {
        email: this.user?.userName,
        plantCode,
        groupCode,
        menuId: menu?.menuId,
        languageName: localStorage.getItem('Language_Name'),
        token: this.baseApi.getTokenFromStorage(),
      };
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(queryParams), this.key, { iv: this.iv })
      this.openUrlWithParameters(appURL, { encrypted: encrypted.toString() })

    } else {
      this.baseApi.saveCurrentMenuID(menu?.menuId);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['Home']));
    }
  }

  navigateToHome(): void {
    this.baseApi.saveCurrentMenuID('');
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['Home']));
  }

  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      this.langObject = res.tagList;
    });
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObject.length > 0) {
      val = this.langObject?.find(f => f.tagName === value)
    }
    return val?.translatedValue;
  }
  openUrlWithParameters(url: string, parameters: { [key: string]: string }): void {
    const queryString = Object.keys(parameters)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`)
      .join('&');
    const urlWithParameters = `${url}?${queryString}`;
    window.open(urlWithParameters, '_self');
  }
}
